<template>
	<Layout>
		<div>
			<!-- Header  -->
			<div class="row">
				<div class="col-12">
					<div class="page-title-box d-flex align-items-center justify-content-between icon-main-page">
						<div class="page-title-left">
							<div class="avatar-xs mr-3">
							<span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
								<i class="bx bx-user-circle"></i>
							</span>
							</div>
							<h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Free Cash') }}</h4>
						</div>
						<div class="page-title-right">
							
						</div>
					</div>
				</div>
			</div>

			<!-- Table and Filter  -->
			<div class="row list-table-main">
				<div class="col-12">
					<div class="card">
						<div class="card-body">

							<!-- Filter -->
							<div class="row">
								<div class="col-md-12 mb-2">
									<h6>{{ trans.get('__JSON__.Free Cash Note') }}</h6>
								</div>
								<div class="col-sm-6">
									<div class="row">
										<div class="col-md-2">
											<b-form-group id="input-group-1" :label="trans.get('__JSON__.Days')" label-for="days">
												<b-form-input
													v-model="filters.days" 
													type="number"
													:placeholder="trans.get('__JSON__.Days')"
												></b-form-input>
											</b-form-group>
										</div>
										<div class="col-md-3">
											<b-form-group id="input-group-1" :label="trans.get('__JSON__.Number of Orders')" label-for="days">
												<b-form-input
													v-model="filters.orders" 
													type="number"
													:placeholder="trans.get('__JSON__.Orders')"
												></b-form-input>
											</b-form-group>
										</div>

										<div class="col-md-3">
											<b-form-group id="input-group-1" :label="trans.get('__JSON__.Order Value')" label-for="days">
												<b-form-input
													v-model="filters.orderValue" 
													type="number"
													:placeholder="trans.get('__JSON__.Order Value')"
												></b-form-input>
											</b-form-group>
										</div>
										<div class="col-md-3 d-flex align-items-center">
											<b-button variant="primary" class="btn-block" @click="filterData" v-if="$auth.hasPermission(config.permissions.free_cash_write)">{{ trans.get('__JSON__.Filter') }}</b-button>
										</div>
									</div>
								</div>

								<div class="col-sm-6">
									<div class="row d-flex align-items-center justify-content-end">
										<div class="col-md-3">
											<b-button 
											variant="success" 
											class="btn-block"
											v-if="$auth.hasPermission(config.permissions.free_cash_write) && customersList.length > 0 && selectedCustomers.length > 0"
											@click="openAddFreeCashModal"
											:placeholder="trans.get('__JSON__.Add free cash to selected customers')"
											>{{ trans.get('__JSON__.Add Free Cash') }}</b-button>
										</div>
									</div>
								</div>
							</div>

							<div class="row mt-3">
								<div class="col-12 table-main-list table-responsive">
									<span class="text-primary" style="font-size: 14px;" v-if="filters.days > 0">
										<span v-if="filters.days > 0">List of customers who have placed <b>{{ filters.orders || 0 }}</b> 
											order within the past <b>{{ filters.days || 0 }}</b> days </span> 
										<span v-if="filters.orders > 0 && filters.orderValue > 0">, with an average order value of <b>{{ filters.orderValue }}</b>. </span>
									</span>
									<b-table
									:items="customersList"
									:fields="fields"
									:sort-by.sync="sortBy"
									:sort-desc.sync="sortDesc"
									:no-local-sorting="true"
									:busy="loading"
									show-empty
									>

									<template #head(select) v-if="customersList.length > 0">
										<b-form-checkbox
											v-model="selectAll"
											@change="toggleSelectAll"
										></b-form-checkbox>
									</template>
									
									<template #cell(select)="row">
										<b-form-checkbox
											v-model="selectedCustomers"
											:value="row.item.user_id"
											@change="updateSelectAll"
										></b-form-checkbox>
									</template>

									<template #table-busy>
										<div class="text-center text-danger my-2">
										<b-spinner class="align-middle"></b-spinner>
										<strong>{{trans.get('__JSON__.Loading...')}}</strong>
										</div>
									</template>

									<template #empty>
										<p class="text-center">{{ trans.get('__JSON__.No Customer') }}</p>
									</template>
									</b-table>
								</div>
								<div class="row col-sm-5 offset-sm-7">
									<div class="col">
										<div class="dataTables_paginate paging_simple_numbers float-right">
											<ul class="pagination pagination-rounded mb-0">
											<pagination
												:data="paginations"
												:limit="limit"
												@pagination-change-page="filterData"
												></pagination>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

	  	</div>
		
		<addFreeCashModal 
			:customersIds = "selectedCustomers" 
			:openModel = "openModel"
			@hidden = "openModel = false"
			@clear-filters = "clearFilters"
			@loader="loader"
			v-if="$auth.hasPermission(config.permissions.free_cash_write)"
		/>

	</Layout>
</template>

<script>
	import Layout from "../../../layouts/main";
	import PageHeader from "../../../components/page-header";
	import pagination from "laravel-vue-pagination";
	import { customerService } from "../../../services";
	import addFreeCashModal from "./add-free-cash.vue";
	import config from "../../../config";

	export default {
		components : {
			Layout,
			PageHeader,
			pagination,
			addFreeCashModal
		},
		data() {
			return {
				fields: [
					{ key: 'select', label: '', sortable: false },
					{ key: 'customer_unique_code', label: 'Customer Id' },
					{ key: 'customer_name', label: 'Name' },
					{ key: 'email', label: 'Email' },
					{ key: 'orders_count', label: 'No. of Orders' },
					{ key: 'avg_order_value', label: 'Average Order Value'},
				],
				loading: false,
				sortBy: 'created_at',
				sortDesc: true,
				filters: {
					days: '',
					orders: '',
					orderValue: ''
				},
				customersList: [],
				openModel: false,
				customersIds: [],
				selectedCustomers: [],
				selectAll: false,
				paginations: {},
				limit: 10,
				config: config
			}
		},
		methods: {
			filterData(page = 1) 
			{
				this.loading = true
				var filter = this.filters;
				customerService
					.getCustomesWithFilters({
						filter, 
						page: page,
						vendor_id: this.$auth.getVendorId()
					 })
					.then(response => {
						if(response?.data?.code === 200)
						{
							this.customersList = response?.data?.result?.customers?.data || [];
							this.paginations = response?.data?.result?.customers || [];
							this.customersIds = response?.data?.result?.customers_ids || [];
							// Preserve selections across page changes if still present
							this.selectedCustomers = this.selectedCustomers.filter(id => 
								this.customersList.some(customer => customer.user_id === id)
							);
							this.updateSelectAll();
						}

						this.loading = false
					})
					.catch(error => {
						console.error(error);
						this.loading = false;
					});
			},
			openAddFreeCashModal() {
				this.openModel = true;
			},
			clearFilters() 
			{
				this.customersIds = [];
				this.customersList = [];
				this.selectedCustomers = [];
				this.selectAll = false;
				this.filters.days = '';
				this.filters.orders = '';
				this.filters.orderValue = '';
				this.loading = false;
			},
			loader(value)
			{
				console.log(value);
				
				this.loading = value;
			},
			toggleSelectAll(checked) {
				if (checked) {
					this.selectedCustomers = this.customersList.map(customer => customer.user_id);
				} else {
					this.selectedCustomers = [];
				}
			},
			updateSelectAll() {
				this.selectAll = this.customersList.length > 0 && 
					this.customersList.every(customer => 
						this.selectedCustomers.includes(customer.user_id)
				);
			}
		}
	}
</script>